/**
 * HOF-216 — how the custom edge component reaches the unlink.
 *
 * ``edgeTypes`` is a module-level constant (it must be referentially stable,
 * or ReactFlow remounts every edge on each render), so ``MatchedLineEdge``
 * cannot be given props by ``MatchGraph``. A context is the idiomatic way in:
 * ``MatchGraph`` provides it around ``<ReactFlow>``, and provides ``null``
 * when ``onManualUnlink`` is absent — which is what makes a Storybook or
 * standalone render show no control at all (AC 7).
 */
import { createContext, useContext } from 'react';

import type { EdgeLike } from '../lineLinkValidation';
import type { LineUnlinkTrigger } from '../lineUnlinkTelemetry';

export interface MatchedLineEdgeActions {
  requestUnlink: (edge: EdgeLike, trigger: LineUnlinkTrigger) => boolean;
}

export const MatchedLineEdgeActionsContext = createContext<MatchedLineEdgeActions | null>(null);

export function useMatchedLineEdgeActions(): MatchedLineEdgeActions | null {
  return useContext(MatchedLineEdgeActionsContext);
}
